export var HttpHeaderType;
(function (HttpHeaderType) {
    HttpHeaderType["CONTENT_TYPE"] = "Content-Type";
    HttpHeaderType["XMI_REQUEST_ID"] = "X-Mi-Request-Id";
    HttpHeaderType["XMI_CALLER"] = "X-Mi-Caller";
    HttpHeaderType["X_REPORT_TYPE"] = "x-report-type";
    HttpHeaderType["X_TIME_ZONE_OFFSET"] = "X-Time-Zone-Offset";
    HttpHeaderType["ID_COUNTRY"] = "ID_Country";
    HttpHeaderType["ACCEPT_LANGUAGE"] = "Accept-Language";
    HttpHeaderType["ACCEPT"] = "accept";
    HttpHeaderType["RESPONSE_TYPE"] = "responseType";
    HttpHeaderType["ROUTING_CONTEXT"] = "routingContext";
    HttpHeaderType["IF_MATCH"] = "If-Match";
    HttpHeaderType["PRAGMA"] = "Pragma";
    HttpHeaderType["CONNECTION"] = "Connection";
    HttpHeaderType["X_MI_EXPLANATION_LINES"] = "X-Mi-Explanation-Lines";
    HttpHeaderType["X_MI_APPLICATION_NAME"] = "X-Mi-Application-Name";
    HttpHeaderType["X_MI_REQUESTTYPE"] = "X-Mi-RequestType";
    HttpHeaderType["X_MI_RECOMMENDED_OP"] = "X-Mi-RecommendedOp";
    HttpHeaderType["CACHE_ENABLED"] = "Cache-Enabled";
    HttpHeaderType["REQUEST_SAVED_DATA"] = "requestSavedData";
    HttpHeaderType["X_SELECTED_ORG"] = "X-Selected-Org";
    HttpHeaderType["X_MI_EXCLUDE"] = "X-Mi-Exclude";
})(HttpHeaderType || (HttpHeaderType = {}));
//# sourceMappingURL=HttpHeaderType.js.map